import request from '@/utils/request'

export function createOrder(data) {
  return request.post('/order/create', data)
}

export function mockPayOrder(data) {
  return request.post('/order/mockPay', data)
}
